// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_et-0";